var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOrderItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "work-order-item",
    width: "47px",
    height: "56px",
    viewBox: "0 0 47 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "work-order-item-1",
    d: "M43.9650879,4 L56,16.1772461 L56,53.1381836 L49,53.0100098 L49,60 L9,60 L9,11 L16,11 L16,4 L43.9650879,4 Z M16,14 L12,14 L12,57 L46,57 L46,53.0100098 L53,53.0100098 L53,53 L16,53 L16,14 Z M43.2298039,27 L33.2133333,36.6171429 L28.7701961,32.3428571 L25,36.0342857 L33.2133333,44 L47,30.6914286 L43.2298039,27 Z M43.977,8.28 L44,16 L51.719,16.114 L43.977,8.28 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work-order-item-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-order-item-3",
    transform: "translate(-9.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "word-order-item-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "work-order-item-5",
    xlinkHref: "#work-order-item-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "work-order-item-6",
    className: "fill-selector",
    fill: "#151515",
    fillRule: "nonzero",
    xlinkHref: "#work-order-item-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrderItem);
export default __webpack_public_path__ + "static/media/work-order-item.91b491bc3f8ea38837a3181d0e1a962c.svg";
export { ForwardRef as ReactComponent };